// Petits utilitaires DOM/erreurs partagés par (presque) tous les modules du taskpane -- pas de
// dépendance sur l'état applicatif (mailData, réponse en cours, etc.), volontairement.
import { ServiceUnavailableError } from "../praetoria";

export function bindActivate(elementId: string, handler: () => void): void {
  const element = document.getElementById(elementId);
  element.onclick = handler;
  element.onkeydown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

// Une ServiceUnavailableError (panne de base côté serveur, voir main.py) porte déjà un message
// clair et non alarmant ("réessayez dans quelques instants") -- on l'affiche telle quelle plutôt
// que de l'envelopper dans "Impossible de X (...)", qui suggérerait à tort un problème définitif.
export function describeActionError(prefix: string, error: unknown): string {
  if (error instanceof ServiceUnavailableError) {
    return error.message;
  }
  return `${prefix} (${errorMessage(error)}).`;
}

export function openDialogPage(page: string): void {
  const url = `${window.location.origin}/${page}`;
  Office.context.ui.displayDialogAsync(url, { height: 60, width: 40 }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      console.error(`Impossible d'ouvrir ${page}`, result.error);
    }
  });
}
